module.exports = __webpack_public_path__ + "img/管理一体化.5e8a6464.png";